import { RenderSeaCardProps } from "entities/shared/seaCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { SeaSavedCardModel } from "../model/model";
type UsePrepareCardUpdateActionsReturnType = {
  updateCard: (model: SeaSavedCardModel) => void;
  shouldUpdateCard: () => boolean;
  isResolvingUpdatePossibility: boolean;
  isCardUpdateSuccess: boolean;
  isCardUpdating: boolean;
};

type SeaSavedCardProps = {
  shipmentType: ValueOf<typeof ShipmentType>;
  data: SeaSavedCardModel;
  openCard: (data: SeaSavedCardModel) => void;
  isSavedCardDeleting: boolean;
  useSavedCardUpdateActions: () => UsePrepareCardUpdateActionsReturnType;
  deleteCardHandler: (card: SeaSavedCardModel) => void;
  renderCard: (props: RenderSeaCardProps) => JSX.Element;
};

export const SeaSavedCard: RFC<SeaSavedCardProps> = ({
  shipmentType,
  data,
  openCard,
  isSavedCardDeleting,
  useSavedCardUpdateActions,
  deleteCardHandler,
  renderCard,
}) => {
  const { updateCard, shouldUpdateCard, isResolvingUpdatePossibility, isCardUpdating } = useSavedCardUpdateActions();

  const onDeleteHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    deleteCardHandler(data);
  };

  const onOpenHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    openCard(data);
  };

  const onUpdateHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    updateCard(data);
  };

  return renderCard({
    shipmentType,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    predictiveETA: data.predictiveETA,
    referenceType: data.referenceType,
    containersAmount: data.containersAmount,
    reference: data.reference,
    status: data.status,
    directionFrom: data.fromDirection,
    directionTo: data.toDirection,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
    onUpdate: onUpdateHandler,
    canUpdate: shouldUpdateCard(),
    isUpdating: isResolvingUpdatePossibility,
    isDeleteProcessing: isSavedCardDeleting,
    containersSizeTypes: data.containersSizeTypes,
    scac: data.carrierScac,
    carrierName: data.carrierName,
    tags: data.tags,
  });
};

SeaSavedCard.displayName = SeaSavedCard.name;
